var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Drawer from './Drawer';
import { trStyles, tdStyles } from './shared';
import { getPublicRowStateProps, TableCellProvider, useDrawer, } from '../utils';
import { useFocus } from '../../tools/utils';
var StyledTr = styled.tr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  td:nth-child(n + 2) {\n    text-align: right;\n  }\n"], ["\n  ", "\n\n  td:nth-child(n + 2) {\n    text-align: right;\n  }\n"
    // increased specificity is used to override the nth-child selector above
])), trStyles);
// increased specificity is used to override the nth-child selector above
var StyledTd = styled.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), tdStyles, function (_a) {
    var alignment = _a.alignment;
    return alignment ? "&&& { text-align: ".concat(alignment, " }") : '';
});
var StyledTh = styled.th(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  font-weight: normal;\n  text-align: ", ";\n"], ["\n  ", "\n  font-weight: normal;\n  text-align: ", ";\n"])), tdStyles, function (_a) {
    var alignment = _a.alignment;
    return alignment || 'left';
});
var TableRow = function (_a) {
    var row = _a.row, index = _a.index, rowClickHandler = _a.rowClickHandler, _b = _a.selectRow, selectRow = _b === void 0 ? null : _b, withRowHeadings = _a.withRowHeadings, drawer = _a.drawer, tableInstance = _a.tableInstance, rowToFocus = _a.rowToFocus;
    var _c = useDrawer(row), toggleDrawer = _c.toggleDrawer, closeDrawerAndFocus = _c.closeDrawerAndFocus, isDrawerOpen = _c.isDrawerOpen, drawerTriggerRef = _c.drawerTriggerRef, drawerTargetRef = _c.drawerTargetRef;
    var cellDrawerProps = {
        isDrawerOpen: isDrawerOpen,
        toggleDrawer: toggleDrawer,
        drawerTriggerRef: drawerTriggerRef,
    };
    var tableCellContext = __assign(__assign(__assign({}, cellDrawerProps), getPublicRowStateProps(row)), { data: row.original });
    var _d = __read(useFocus(), 2), focusRef = _d[0], setFocus = _d[1];
    var _e = __read(useState(false), 2), rowIsFocused = _e[0], setRowIsFocused = _e[1];
    var rowToFocusRef = useRef(rowToFocus);
    useEffect(function () {
        if (rowToFocus !== rowToFocusRef.current) {
            setRowIsFocused(false);
        }
        if (index === rowToFocus && !rowIsFocused) {
            setFocus();
            setRowIsFocused(true);
            rowToFocusRef.current = rowToFocus;
        }
    }, [index, rowToFocus, rowIsFocused, setFocus]);
    // cells are wrapped in divs to prevent an issue with NVDA sometimes "merging" cells when they are read
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTr, __assign({}, row.getRowProps(), (rowClickHandler && {
            onClick: function () {
                rowClickHandler({ index: index, data: row.original });
            },
        }), { className: [selectRow === index && 'selected', index % 2 && 'even']
                .filter(Boolean)
                .join(' '), ref: focusRef, tabIndex: -1 }), row.cells.map(function (cell, i) {
            if (withRowHeadings && i === 0) {
                return (React.createElement(StyledTh, __assign({ scope: "row", alignment: cell.column.alignment }, cell.getCellProps()),
                    React.createElement("div", null,
                        React.createElement(TableCellProvider, { value: tableCellContext }, cell.render('Cell', cellDrawerProps)))));
            }
            return (React.createElement(StyledTd, __assign({ alignment: cell.column.alignment }, cell.getCellProps()),
                React.createElement("div", null,
                    React.createElement(TableCellProvider, { value: tableCellContext }, cell.render('Cell', cellDrawerProps)))));
        })),
        drawer && (React.createElement(Drawer, __assign({}, {
            tableInstance: tableInstance,
            row: row,
            drawer: drawer,
            closeDrawerAndFocus: closeDrawerAndFocus,
            isDrawerOpen: isDrawerOpen,
            drawerTargetRef: drawerTargetRef,
        })))));
};
export default TableRow;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TableRow.js.map